"use client";

import { useMemo } from "react";
import { useSearchParams } from "next/navigation";
import { PageTypePortal } from "@/lib/types";
import { getPostAuthRedirectPath } from "@/lib/utils/auth/postAuthRedirect";
import { buildMemberSetupUrl } from "@/lib/member-setup/member-setup-routes";
import { AuthRedirectView } from "./AuthRedirectView";

export const SignUpSuccessView = () => {
  const searchParams = useSearchParams();

  const redirectPath = useMemo(() => {
    const callbackUrl = searchParams.get("callbackUrl");
    const next = getPostAuthRedirectPath(callbackUrl);
    const nextForSetup = next !== PageTypePortal.Dashboard ? next : null;

    return buildMemberSetupUrl({
      source: "signup",
      next: nextForSetup,
    });
  }, [searchParams]);

  const isClassRegistrationRedirect = useMemo(() => {
    const callbackUrl = searchParams.get("callbackUrl");
    const next = getPostAuthRedirectPath(callbackUrl);
    return next.startsWith(PageTypePortal.ClassRegistration);
  }, [searchParams]);

  const statusMessage = isClassRegistrationRedirect
    ? "Setting up your account, then class registration…"
    : "Setting up your account…";

  return (
    <AuthRedirectView
      redirectPath={redirectPath}
      title="You're all set"
      statusMessage={statusMessage}
      showLogo
    />
  );
};
